const StaffInstructions = () => (
  <div className="rounded-lg border border-blue-200 bg-blue-50 p-5 text-sm text-gray-800 space-y-4">
    <div>
      <h3 className="font-semibold text-gray-900 mb-2">End of service — what to log</h3>
      <ul className="space-y-1.5">
        <li><span className="font-medium">Cooked</span> — Total prepared today, including anything not yet served.</li>
        <li><span className="font-medium">Stored</span> — What's going into the fridge tonight; closes today's balance.</li>
        <li><span className="font-medium">Wasted</span> — Thrown away during service (wrong orders, accidents, quality).</li>
        <li><span className="font-medium">Expired</span> — Stored food from a previous day that's no longer usable.</li>
        <li><span className="font-medium">Staff consumption</span> — Food eaten by kitchen staff during service. Log it here, not under wasted.</li>
        <li><span className="font-medium">Outside sales</span> — Portions that left via Thuisbezorgd, Uber Eats, catering, or other. Revenue not required.</li>
      </ul>
      <p className="mt-2 text-gray-600">
        <span className="font-medium">Do not log</span> sold via POS — filled in automatically from orders.
      </p>
    </div>

    <div>
      <h3 className="font-semibold text-gray-900 mb-2">Next morning — before service</h3>
      <ul className="space-y-1.5">
        <li><span className="font-medium">Reheated</span> — Food coming out of storage and back into service. Log the quantity being reheated.</li>
        <li>If stored food is no longer usable, log it as <span className="font-medium">Expired</span> instead.</li>
        <li>If the session was already submitted, use <span className="font-medium">Reopen</span>, add the entry, then resubmit.</li>
      </ul>
    </div>

    <div>
      <h3 className="font-semibold text-gray-900 mb-2">General rules</h3>
      <ul className="space-y-1.5">
        <li>Always use the unit shown next to each dish (kg, pieces, litres).</li>
        <li>Estimate if unsure — a close number is better than nothing.</li>
        <li>Log stored food the same night it goes in the fridge.</li>
        <li>You can back-date entries using yesterday's date if you forgot something.</li>
      </ul>
    </div>
  </div>
)

export default StaffInstructions
